export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11229.cb3fa77c.jpg";